import React, { FC } from 'react';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import styles from './allocationsStyles.scss';

const AllocationItem: FC<{
  company: string;
  amount: string;
  publicationFileUrl: string;
  image: string;
}> = ({ amount, company, image, publicationFileUrl }) => (
  <div className={styles.allocationsItem}>
    <img src={image} />
    <div>
      <strong>{company}</strong>
      <h4>
        <em>{amount}</em> Allocation
      </h4>
    </div>
    <Button
      faIcon={faFilePdf}
      size={BUTTON_SIZES.SMALL}
      target="_blank"
      text="View PDF"
      type={BUTTON_TYPES.LINK}
      url={publicationFileUrl}
    />
  </div>
);

const Allocations: FC<{
  allocations: { company: string; amount: string; publicationFileUrl: string; image: string }[];
}> = ({ allocations }) => {
  return (
    <div className={styles.allocations}>
      <h4>Success on Cap Intro</h4>
      <p>
        Cap Intro is a high-quality exposure tool that guarantees recurring exposure to the
        continuously growing group of allocators.
      </p>
      <p>
        Not all funds will receive allocations. However, up to January 2018, SumZero has documented
        roughly $375M of allocations made across nearly 5 dozen transactions. These reports have
        been made voluntarily, and therefore represent a fraction of the total value of
        transactional flow catalyzed.
      </p>
      <div className={styles.allocationsWrapper}>
        <div className={styles.allocationsScrollContainer}>
          <div className={styles.allocationsTrack}>
            {allocations.map(allocation => (
              <AllocationItem key={allocation.company} {...allocation} />
            ))}
            {allocations.map(allocation => (
              <AllocationItem key={`duplicate-${allocation.company}`} {...allocation} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Allocations;
